// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"dd9e9068dc1191c91d11","303":"3a702180b3ec7ed13943","495":"b4243a36a078acd3d357"}[chunkId] + ".js";
};